import { cfgHasSports, toTileCdn } from '@infinitro/config';
export const sportsFomo = cfgHasSports()
    ? [
        {
            prov: 'Sports',
            game: 'soccer-1',
            tile: toTileCdn(`t/sports/soccer.png`)
        },
        {
            prov: 'Sports',
            game: 'basketball-2',
            tile: toTileCdn(`t/sports/basketball.png`)
        },
        {
            prov: 'Sports',
            game: 'baseball-3',
            tile: toTileCdn(`t/sports/baseball.png`)
        },
        {
            prov: 'Sports',
            game: 'tennis-5',
            tile: toTileCdn(`t/sports/tennis.png`)
        },
        {
            prov: 'Sports',
            game: 'boxing-10',
            tile: toTileCdn(`t/sports/boxing.png`)
        },
        {
            prov: 'Sports',
            game: 'mma-117',
            tile: toTileCdn(`t/sports/mma.png`)
        },
        {
            prov: 'Sports',
            game: 'table-tennis-20',
            tile: toTileCdn(`t/sports/table_tennis.png`)
        },
        {
            prov: 'Sports',
            game: 'american-football-16',
            tile: toTileCdn(`t/sports/american_football.png`)
        },
        {
            prov: 'Sports',
            game: 'handball-16',
            tile: toTileCdn(`t/sports/handball.png`)
        },
        {
            prov: 'Sports',
            game: 'volleyball-23',
            tile: toTileCdn(`t/sports/volleyball.png`)
        },
        {
            prov: 'Sports',
            game: 'darts-22',
            tile: toTileCdn(`t/sports/darts.png`)
        },
        {
            prov: 'Sports',
            game: 'ehorse-racing-315',
            tile: toTileCdn(`t/sports/horse_racing.png`)
        },
        {
            prov: 'Sports',
            game: 'ice-hockey-4',
            tile: toTileCdn(`t/sports/ice_hockey.png`)
        },
        {
            prov: 'Sports',
            game: 'formula-1-40',
            tile: toTileCdn(`t/sports/formula_1.png`)
        },
        {
            prov: 'Sports',
            game: 'rugby-union-12',
            tile: toTileCdn(`t/sports/rugby.png`)
        }
    ]
    : [];
